export default "__VITE_ASSET__HH$qZjsD__"